var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFailedOpacity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92894 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.76121 8.17317C3.51809 6.34591 4.79981 4.78412 6.4443 3.6853ZM16.7537 8.42723L13.1739 11.9993L16.7537 15.5713C16.9113 15.7277 17 15.9405 17 16.1625C17 16.3845 16.9113 16.5974 16.7537 16.7537C16.5974 16.9113 16.3846 17 16.1626 17C15.9407 17 15.7279 16.9113 15.5715 16.7537L12 13.1733L8.42845 16.7537C8.27213 16.9113 8.05934 17 7.83736 17C7.61537 17 7.40258 16.9113 7.24626 16.7537C7.08865 16.5974 7 16.3845 7 16.1625C7 15.9405 7.08865 15.7277 7.24626 15.5713L10.8261 11.9993L7.24626 8.42723C6.91981 8.10073 6.91981 7.57137 7.24626 7.24487C7.57271 6.91838 8.102 6.91838 8.42845 7.24487L12 10.8253L15.5715 7.24487C15.898 6.91838 16.4273 6.91838 16.7537 7.24487C17.0802 7.57137 17.0802 8.10073 16.7537 8.42723Z",
    fill: "#FFAC82"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFailedOpacity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/failed_opacity.2416626328e897d925caf81804aa039a.svg";